import PointAlarmsPrototypeProvider from '../../providers/PointAlarmsPrototypeProvider'

class PointAlarmsPrototypeService {
  async getAlgorithms (token) {
    return PointAlarmsPrototypeProvider.getAlgorithms(token)
  }

  async getAssetWithAlgorithms (asset, languageCode, token) {
    return PointAlarmsPrototypeProvider.getAssetWithAlgorithms(asset, languageCode, token)
  }

  async getAvailableAlgorithms (asset, languageCode, token) {
    return PointAlarmsPrototypeProvider.getAvailableAlgorithms(asset, languageCode, token)
  }

  async removeAlgorithm (asset, token, algorithmId) {
    return PointAlarmsPrototypeProvider.removeAlgorithm(asset, token, algorithmId)
  }

  async updateStartDate (asset, token, startDate) {
    return PointAlarmsPrototypeProvider.updateStartDate(asset, token, startDate)
  }

  async previewBackgroundWorker (asset, token, algorithmSetting, startDate, sectionType) {
    return PointAlarmsPrototypeProvider.previewBackgroundWorker(asset, token, algorithmSetting, startDate, sectionType)
  }

  async updateAlgorithmSections (asset, token, algorithmSetting) {
    return PointAlarmsPrototypeProvider.updateAlgorithmSections(asset, token, algorithmSetting)
  }

  async getUser () {
    return PointAlarmsPrototypeProvider.getUser()
  }

  async getAvailablesections (asset, token, languageCode) {
    return PointAlarmsPrototypeProvider.getAvailablesections(asset, token, languageCode)
  }

  async getSections (asset, token) {
    return PointAlarmsPrototypeProvider.getSections(asset, token)
  }

  async createSections (asset, token, sections, direction) {
    return PointAlarmsPrototypeProvider.createSections(asset, token, sections, direction)
  }

  async updateSections (asset, token, sections) {
    return PointAlarmsPrototypeProvider.updateSections(asset, token, sections)
  }

  async getSectionsByDirection (asset, token, direction) {
    return PointAlarmsPrototypeProvider.getSectionsByDirection(asset, token, direction)
  }

  async getSingleReferenceCurve (asset, token, direction) {
    return PointAlarmsPrototypeProvider.getSingleReferenceCurve(asset, token, direction)
  }

  // OLD BELOW

  async getAlgorithmParameters (algorithm, token) {
    return PointAlarmsPrototypeProvider.getAlgorithmParameters(algorithm, token)
  }

  async getAlgorithmParametersById (algorithm, token) {
    return PointAlarmsPrototypeProvider.getAlgorithmParametersById(algorithm, token)
  }

  async createAlgorithmSetting (asset, token, algorithmSetting) {
    return PointAlarmsPrototypeProvider.createAlgorithmSetting(asset, token, algorithmSetting)
  }

  async updateAlgorithmSetting (asset, token, algorithmSetting) {
    return PointAlarmsPrototypeProvider.updateAlgorithmSetting(asset, token, algorithmSetting)
  }

  async removeAlgorithmSetting (asset, token, id) {
    return PointAlarmsPrototypeProvider.removeAlgorithmSetting(asset, token, id)
  }

  async getHealthScore (asset, token, from, to, direction, days) {
    return PointAlarmsPrototypeProvider.getHealthScore(asset, token, from, to, direction, days)
  }
}

export default new PointAlarmsPrototypeService()



// WEBPACK FOOTER //
// ./src/services/r8/PointAlarmsPrototypeService.js